import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setAutoTranslateLanguage, setTranslationStatus } from "store/app/app.actions";
import useApp from "./useApp";

const useToggleTranslate = () => {
    const { bchat } = window;
    const { contactId, noTranslations } = useApp();
    const dispatch = useDispatch();

    const toggleTranslate = useCallback(async (language?: string, on?:boolean) => {
        if (!contactId) return;

        await bchat.toggleAutoTranslate({
            contactId,
            translateMessages: !!on,
            translationLanguage: on ? language : undefined,
            noTranslations: on ? noTranslations : undefined,
        })
        
        dispatch(setTranslationStatus(!!on))
        dispatch(setAutoTranslateLanguage(language))

    }, [contactId, dispatch, bchat, noTranslations])


    return toggleTranslate
}

export default useToggleTranslate;